<template>
  <div class="payment-status" v-cloak>
    <div class="iconfont icon-duihao2 bg-color-red" v-if="showSuccessIcon"></div>
    <div class="iconfont icon-iconfontguanbi fail" v-else></div>

    <div class="status">{{ statusText }}</div>

    <template v-if="showOrderDetail">
      <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
          <div>订单编号</div>
          <div class="itemCom" v-text="orderInfo.order_id"></div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>下单时间</div>
          <div class="itemCom" v-text="orderInfo._add_time"></div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>支付方式</div>
          <div class="itemCom">
            {{ orderInfo.buyMethod != "quanKuan" ? orderInfo.buyMethodDes : orderInfo._status._payType }}
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>支付金额</div>
          <div class="itemCom" v-text="orderInfo.pay_price"></div>
        </div>
        <div class="item acea-row row-between-wrapper" v-if="orderInfo.buyMethod != 'quanKuan'">
          <div>温馨提示</div>
          <div class="itemCom">{{ msgContent }}</div>
        </div>
        <div
          class="item acea-row row-between-wrapper"
          v-else-if="orderInfo.paid == 0 && orderInfo.pay_type != 'offline' && msgContent"
        >
          <div>失败原因</div>
          <div class="itemCom" v-text="msgContent"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
          <div>订单编号</div>
          <div class="itemCom" v-text="displayOrderId"></div>
        </div>
        <div class="item acea-row row-between-wrapper" v-if="alipayTotalAmount">
          <div>支付金额</div>
          <div class="itemCom">￥{{ alipayTotalAmount }}</div>
        </div>
        <div class="item acea-row row-between-wrapper" v-if="guestTip">
          <div>温馨提示</div>
          <div class="itemCom">{{ guestTip }}</div>
        </div>
        <div class="item acea-row row-between-wrapper" v-if="alipayTradeNo">
          <div>交易号</div>
          <div class="itemCom">{{ alipayTradeNo }}</div>
        </div>
      </div>
    </template>

    <div class="constomerQr" v-if="customerQrUrl != ''">
      <div class="tips">请长按添加客服号，方便安排发货等事宜</div>
      <div class="qr">
        <img :src="customerQrUrl" class="qr-image" />
      </div>
    </div>

    <template v-if="showOrderDetail">
      <div class="returnBnt bg-color-red" @click="goPages()">查看订单</div>
      <div style="height: 0.3rem;"></div>
      <div class="returnBnt cart-color" @click="goPages('/')">返回首页</div>
    </template>
    <template v-else>
      <div style="height: 0.3rem;"></div>
      <div class="returnBnt bg-color-red" @click="goPages('/')">返回首页</div>
      <div style="height: 0.3rem;"></div>
    </template>
  </div>
</template>

<style>
.payment-status .constomerQr {
  border-bottom: 1px solid #eee;
  margin: -0.47rem 0.30rem 0.47rem 0.30rem;
  padding-top: 0.35rem;
  border-left: 0;
  border-right: 0;
}

.payment-status .constomerQr .tips {
  font-size: 0.26rem;
  text-align: center;
  color: #666;
}

.payment-status .constomerQr .qr {
  text-align: center;
}
.payment-status .constomerQr .qr .qr-image {
  width: 3rem;
  height: 3rem;
}
</style>

<script>
import { orderDetail } from "@api/order";
import { isWeixin } from "@utils";
import { getCustomerQr } from "@api/public";

const NAME = "PayMentStatus";

export default {
  name: NAME,
  props: {},
  data: function() {
    return {
      id: "",
      status: 0,
      msgContent: "",
      orderInfo: {},
      isWeixin: isWeixin(),
      customerQrUrl: ""
    };
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.app.token;
    },
    showOrderDetail() {
      return this.isLoggedIn && !!this.orderInfo.order_id;
    },
    displayOrderId() {
      return this.orderInfo.order_id || this.id;
    },
    alipayTotalAmount() {
      return this.$route.query.total_amount || "";
    },
    alipayTradeNo() {
      return this.$route.query.trade_no || "";
    },
    showSuccessIcon() {
      if (this.showOrderDetail) {
        return (
          this.orderInfo.paid ||
          this.orderInfo.pay_type == "offline" ||
          this.orderInfo.buyMethod != "quanKuan"
        );
      }
      return this.status === 1;
    },
    statusText() {
      if (this.showOrderDetail) {
        if (
          this.orderInfo.pay_type != "offline" &&
          this.orderInfo.buyMethod == "quanKuan"
        ) {
          return this.orderInfo.paid ? "订单支付成功" : "订单支付失败";
        }
        return "订单创建成功";
      }
      if (this.status === 1) {
        return "订单支付成功";
      }
      if (this.status === 2) {
        return "支付已取消";
      }
      return "订单支付失败";
    },
    guestTip() {
      if (this.isLoggedIn) {
        return "";
      }
      if (this.status === 1) {
        return "请返回微信查看订单详情";
      }
      if (this.status === 2) {
        return "您已取消支付，可返回微信重新发起支付";
      }
      return "请返回微信查看订单详情";
    }
  },
  watch: {
    $route(n) {
      if (n.query.msg) {
        this.msgContent = n.query.msg;
      }
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.status = parseInt(n.params.status, 10) || 0;
        this.initPage();
      }
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    this.msgContent = this.$route.query.msg || "";
    this.status = parseInt(this.$route.params.status, 10) || 0;
    this.initPage();
    this.getCustomerQr();
  },
  methods: {
    initPage() {
      if (this.isLoggedIn) {
        this.getOrderInfo();
        return;
      }
      document.title = this.status === 1 ? "支付成功" : this.status === 2 ? "支付取消" : "支付失败";
    },
    goPages(route) {
      let routes =
        route !== undefined ? route : "/order/detail/" + this.displayOrderId;
      if (this.status === 5 && route === undefined) {
        routes = "/order/list/0";
      }
      return this.$router.push({
        path: routes
      });
    },
    getOrderInfo() {
      orderDetail(this.id)
        .then(res => {
          this.orderInfo = res.data;
          let title = "";
          if (res.data.buyMethod != "quanKuan") {
            title = "提交成功";
            if (this.msgContent.indexOf("请等待审核结果") === -1) {
              this.msgContent += "，请等待审核结果";
            }
          } else {
            title = res.data.paid ? "支付成功" : "支付失败";
          }
          document.title = title;
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    },
    getCustomerQr() {
      getCustomerQr()
        .then(res => {
          this.customerQrUrl = res.data.customerQrUrl;
        })
        .catch(() => {});
    }
  }
};
</script>
